// src/pages/Register.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "" });
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1); // 1 = Register, 2 = Verify OTP
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle Register
  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/register", form);
      setMessage("✅ OTP sent to your email. Please verify.");
      setStep(2);
    } catch (err) {
      setMessage(err.response?.data?.message || "❌ Registration failed");
    } finally {
      setLoading(false);
    }
  };

  // Handle OTP Verify
  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/verify-otp", { email: form.email, otp });
      setMessage("✅ OTP verified! You can now login.");
      setTimeout(() => navigate("/login"), 1500); // delay before redirect
    } catch (err) {
      setMessage(err.response?.data?.message || "❌ Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  // Handle Resend OTP
  const handleResendOtp = async () => {
    setLoading(true);
    try {
      await api.post("/auth/resend-otp", { email: form.email });
      setMessage("🔄 OTP resent successfully!");
    } catch (err) {
      setMessage(err.response?.data?.message || "❌ Error resending OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen ">
      <div className=" shadow-lg rounded-lg p-8 w-96">
        <h2 className="text-2xl font-bold text-center text-gray-100 mb-6">
          {step === 1 ? "Create Account" : "Verify OTP"}
        </h2>
      
        {message && (
          <p
            className={`text-sm mb-4 text-center ${
              message.startsWith("✅") || message.startsWith("🔄")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {message}
          </p>
        )}

        {step === 1 ? (
          <form onSubmit={handleRegister} className="flex flex-col gap-3">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent text-gray-100"
              value={form.name}
              onChange={handleChange}
              required
              
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent text-gray-100"
              value={form.email}
              onChange={handleChange}
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent text-gray-100"
              value={form.password}
              onChange={handleChange}
              required
            />
            <select
              name="role"
              value={form.role}
              onChange={handleChange}
              className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent text-gray-100"
              required
            >
              <option value="">Select Role</option>
              <option value="User" className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent text-gray-900">User</option>
              {/* <option value="Admin" className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent text-gray-100">Admin</option> */}
            </select>
            <button
              type="submit"
              disabled={loading}
              className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700 transition"
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerify} className="flex flex-col gap-3">
            <input
              type="text"
              placeholder="Enter OTP"
              className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <button
              type="submit"
              disabled={loading}
              className="bg-green-600 text-white p-2 rounded hover:bg-green-700 transition"
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
            <button
              type="button"
              onClick={handleResendOtp}
              disabled={loading}
              className="bg-yellow-500 text-white p-2 rounded hover:bg-yellow-600 transition"
            >
              {loading ? "Resending..." : "Resend OTP"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}





 

                    
                     








